<div *ngIf="show" class="notification">
  <div class="notification__content">
    <i *ngIf="showProgressSpinner" class="notification__spinner"></i>
    <div class="notification__message">{{ message }}</div>
  </div>
</div>
